<template>
  <base-layout>
    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="newMembers.data"
          :options="newMembers.options"
          :responsive-options="newMembers.responsiveOptions"
          color="primary"
          hover-reveal
          type="Bar"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            New members.
          </h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            New members last 7 days.
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated {{ lastUpdate }} minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="avgSpending7Day.data"
          :options="avgSpending7Day.options"
          color="success"
          hover-reveal
          type="Line"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2">
            Average Spent.
          </h4>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            Average Spent for member.
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated {{ lastUpdate }} minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <base-material-chart-card
          :data="countBill.data"
          :options="countBill.options"
          hover-reveal
          color="purple darken-2"
          type="Line"
        >
          <h3 class="card-title font-weight-light mt-2 ml-2">
            Count Order
          </h3>

          <p class="d-inline-flex font-weight-light ml-2 mt-1">
            Count orders last 7 days.
          </p>

          <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated {{ lastUpdate }} minutes ago</span>
          </template>
        </base-material-chart-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-account-multiple-plus"
          title="New Members"
          :value="`+${countNewMember}`"
          sub-icon="mdi-clock"
          sub-text="Last 7 days"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="success"
          icon="mdi-account"
          title="Total Members"
          :value="countNormal"
          sub-icon="mdi-clock"
          :sub-text="`updated ${lastUpdate} minutes ago`"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="purple darken-3"
          icon="mdi-account-star"
          title="Total VIPs"
          :value="countVip"
          sub-icon="mdi-clock"
          :sub-text="`updated ${lastUpdate} minutes ago`"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-currency-usd-circle-outline"
          title="AVG Spent"
          :value="avgSpending"
          sub-icon="mdi-clock"
          :sub-text="`updated ${lastUpdate} minutes ago`"
        />
      </v-col>
    </v-row>
  </base-layout>
</template>

<script>
import MemberProvider from '@/resources/MemberProvider'

const dayjs = require('dayjs')
const advancedFormat = require('dayjs/plugin/advancedFormat')

const memberService = new MemberProvider()
dayjs.extend(advancedFormat)
export default {
  name: 'DashboardDashboard',
  data () {
    return {
      lastUpdate: 'few',
      list7Day: [
        dayjs().subtract(6, 'day').format('dd'),
        dayjs().subtract(5, 'day').format('dd'),
        dayjs().subtract(4, 'day').format('dd'),
        dayjs().subtract(3, 'day').format('dd'),
        dayjs().subtract(2, 'day').format('dd'),
        dayjs().subtract(1, 'day').format('dd'),
        dayjs().format('dd')
      ],
      data: {},
      ready: false,
      mountedDate: null
    }
  },
  computed: {
    countMember () {
      return this.ready ? `${this.data.countMember}` : '0'
    },
    countNormal () {
      return this.ready ? `${this.data.countNormal}` : '0'
    },
    countVip () {
      return this.ready ? `${this.data.countVip}` : '0'
    },
    countNewMember () {
      return this.ready ? `${this.data.newMember7Day.reduce((sum, m) => sum + m.number, 0)}` : '0'
    },
    avgSpending () {
      return this.data.spendingAll ? `${this.data.spendingAll.avg.toFixed(1)}` : '0'
    },
    newMembers () {
      const data = {
        data: {
          labels: this.list7Day,
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 20,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: (value) => value[0]
            }
          }]
        ]
      }

      if (this.ready) {
        data.data.series[0] = this.data.newMember7Day.map((m) => m.number)
        data.options.high = data.data.series[0].reduce((a, b) => Math.max(a, b)) + 5
      }

      return data
    },
    avgSpending7Day () {
      const data = {
        data: {
          labels: this.list7Day,
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 3000,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      }
      if (this.ready) {
        data.data.series[0] = this.data.spending7Day.map((m) => m.avg)
        data.options.high = data.data.series[0].reduce((a, b) => Math.max(a, b)) + 1000
      }
      return data
    },
    countBill () {
      const data = {
        data: {
          labels: this.list7Day,
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      }
      if (this.ready) {
        data.data.series[0] = this.data.spending7Day.map((m) => m.count)
        data.options.high = data.data.series[0].reduce((a, b) => Math.max(a, b)) + 5
      }
      return data
    }
  },
  created () {
    this.mountedDate = dayjs()
    this.getData()
    this.setMin()
  },
  methods: {
    async getData () {
      try {
        const { data } = await memberService.getDashBoard()
        this.data = data
      } catch (err) {
        if (err.status === 401) {
          this.$router.push({ name: 'Login' })
        }
      } finally {
        this.ready = true
      }
    },
    setMin () {
      setInterval(() => {
        const now = dayjs()
        this.lastUpdate = now.diff(this.mountedDate, 'minute')
      }, 60 * 1000)
    }
  }
}
</script>

<style lang="css" scoped>
  .col-xl, .col-xl-auto,
  .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1,
  .col-lg, .col-lg-auto,
  .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1,
  .col-md, .col-md-auto,
  .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1,
  .col-sm, .col-sm-auto,
  .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1,
  .col, .col-auto,
  .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
    padding-top: 40px !important;
  }
</style>
